import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationAccountSetSpaceliftIntelligenceEnabledArgs } from "types/generated";

type SetSpaceliftIntelligenceEnabledData = {
  accountSetSpaceliftIntelligenceEnabled: boolean;
};

export const SET_SPACELIFT_INTELLIGENCE_ENABLED: TypedDocumentNode<
  SetSpaceliftIntelligenceEnabledData,
  MutationAccountSetSpaceliftIntelligenceEnabledArgs
> = gql`
  mutation SetSpaceliftIntelligenceEnabled($enabled: Boolean!) {
    accountSetSpaceliftIntelligenceEnabled(enabled: $enabled)
  }
`;

export const SET_INFRA_ASSISTANT_ENABLED = gql`
  mutation SetInfraAssistantEnabled($enabled: Boolean!) {
    accountSetInfraAssistantEnabled(enabled: $enabled)
  }
`;

export const SET_INFRA_ASSISTANT_BUILD_MODE_ENABLED = gql`
  mutation SetInfraAssistantBuildModeEnabled($enabled: Boolean!) {
    accountSetInfraAssistantBuildModeEnabled(enabled: $enabled)
  }
`;

export const REQUEST_INFRA_ASSISTANT_ENABLING = gql`
  mutation RequestInfraAssistantEnabling {
    accountRequestInfraAssistantEnabling
  }
`;
